import { css } from "@emotion/react";

export const labelStyle = css`
  label {
    font-weight: bold;
  }
`;

export const colGutterStyle = css`
  margin-bottom: 8px;
`;

export const fullWidthNumberInputStyle = css`
  width: 100%;
`;
